var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import ReactModal from "react-modal";
import { Button, Selector, SelectorLabel, } from "../../common-styled-components";
import { LoaderStatus } from "../../../util/apiUtils";
import styled from "styled-components";
import { theme } from "../../../theme";
import Select from "react-select";
import useFetch from "../../../hooks/useFetch";
import useSendFile from "../../../hooks/useSendFile";
var modalStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        minWidth: "280px",
        maxWidth: "640px",
        maxHeight: "80vh",
        overflow: "scroll",
        display: "flex",
    },
};
var ModalContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), theme.spacing(3));
var Form = styled.form(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), theme.spacing(3));
var getTypeOptions = function (metadata) {
    return Object.keys(metadata.report_type).map(function (t) { return ({
        label: metadata.report_type[Number(t)],
        value: Number(t),
    }); });
};
var getPoolOptions = function (pools) {
    return pools.map(function (pool) { return ({
        label: pool.name,
        value: pool.id,
    }); });
};
var getFleetOptions = function (fleets) {
    return fleets.map(function (fleet) { return ({
        label: fleet.name,
        value: fleet.id,
    }); });
};
var ReportUploader = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var title = _a.title, initialBody = _a.initialBody, metadata = _a.metadata;
    var typeOptions = getTypeOptions(metadata);
    var _j = useState(null), file = _j[0], setFile = _j[1];
    var _k = useState((_c = Number((_b = typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions[0]) === null || _b === void 0 ? void 0 : _b.value)) !== null && _c !== void 0 ? _c : null), selectedType = _k[0], setSelectedType = _k[1];
    var _l = useState((_d = initialBody === null || initialBody === void 0 ? void 0 : initialBody.pool_id) !== null && _d !== void 0 ? _d : null), selectedPool = _l[0], setSelectedPool = _l[1];
    var _m = useState((_e = initialBody === null || initialBody === void 0 ? void 0 : initialBody.fleet_id) !== null && _e !== void 0 ? _e : null), selectedFleet = _m[0], setSelectedFleet = _m[1];
    var _o = useState(false), isOpen = _o[0], setOpen = _o[1];
    var overview = useFetch("admin/overview.json")[0];
    var _p = useSendFile("admin/add_report"), sendFile = _p[0], fileSendMessage = _p[1];
    var handleFileChange = function (event) {
        if (event.target.files && event.target.files.length > 0) {
            setFile(event.target.files[0]);
        }
    };
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var formData;
        var _a;
        return __generator(this, function (_b) {
            event.preventDefault();
            if (!file) {
                return [2 /*return*/];
            }
            if (typeOptions && !selectedType) {
                return [2 /*return*/];
            }
            console.info("Sending", file.name, ", report type", (_a = typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.find(function (t) { return t.value === selectedType; })) === null || _a === void 0 ? void 0 : _a.label, ", other options", selectedFleet, selectedPool);
            formData = new FormData();
            // Append the file using the provided fileKey
            formData.append("report", file);
            if (typeOptions && selectedType !== null) {
                formData.append("report_type", selectedType.toString());
            }
            if (selectedFleet !== null) {
                formData.append("fleet_id", selectedFleet.toString());
            }
            if (selectedPool !== null) {
                formData.append("pool_id", selectedPool.toString());
            }
            sendFile(formData);
            return [2 /*return*/];
        });
    }); };
    var fleetOptions = overview.status === LoaderStatus.Success
        ? getFleetOptions(overview.data.fleets)
        : undefined;
    var poolOptions = overview.status === LoaderStatus.Success
        ? getPoolOptions(overview.data.pools)
        : undefined;
    var disabled = selectedFleet === null || selectedPool === null || file === null;
    return (_jsxs("div", { children: [_jsx(ReactModal, __assign({ isOpen: isOpen, onRequestClose: function () { return setOpen(false); }, contentLabel: title, style: modalStyles }, { children: _jsxs(ModalContent, { children: [_jsx("h2", { children: title }), poolOptions && fleetOptions && (_jsxs(Form, __assign({ onSubmit: handleSubmit }, { children: [_jsx("input", { type: "file", onChange: handleFileChange }), typeOptions && (_jsxs(Selector, { children: [_jsx(SelectorLabel, { children: "Report type" }), _jsx(Select, { options: typeOptions, onChange: function (newValue) { var _a; return setSelectedType((_a = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && _a !== void 0 ? _a : null); }, isOptionSelected: function (o) { return (o === null || o === void 0 ? void 0 : o.value) === selectedType; }, value: (_f = typeOptions.find(function (o) { return (o === null || o === void 0 ? void 0 : o.value) === selectedType; })) !== null && _f !== void 0 ? _f : undefined })] })), _jsxs(Selector, { children: [_jsx(SelectorLabel, { children: "Fleet" }), _jsx(Select, { options: fleetOptions, onChange: function (newValue) { var _a; return setSelectedFleet((_a = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && _a !== void 0 ? _a : null); }, isOptionSelected: function (o) { return (o === null || o === void 0 ? void 0 : o.value) === selectedFleet; }, value: (_g = fleetOptions.find(function (o) { return (o === null || o === void 0 ? void 0 : o.value) === selectedFleet; })) !== null && _g !== void 0 ? _g : undefined })] }), _jsxs(Selector, { children: [_jsx(SelectorLabel, { children: "Pool" }), _jsx(Select, { options: poolOptions, onChange: function (newValue) { var _a; return setSelectedPool((_a = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && _a !== void 0 ? _a : null); }, isOptionSelected: function (o) { return (o === null || o === void 0 ? void 0 : o.value) === selectedPool; }, value: (_h = poolOptions.find(function (o) { return (o === null || o === void 0 ? void 0 : o.value) === selectedPool; })) !== null && _h !== void 0 ? _h : undefined })] }), _jsx(Button, __assign({ type: "submit", disabled: disabled }, { children: disabled ? "Select pool, fleet, and file" : "Upload" }))] }))), fileSendMessage && _jsx("p", { children: fileSendMessage }), _jsx(Button, __assign({ onClick: function () { return setOpen(false); } }, { children: "Close" }))] }) })), _jsx(Button, __assign({ onClick: function () { return setOpen(true); } }, { children: title }))] }));
};
export default ReportUploader;
var templateObject_1, templateObject_2;
